<template>
  <div class="policy policy_service">
    <item-title :title="{ name: '保单服务', en_1: 'POLICY', en_2: 'SERVICES' }" />
    <div class="policy-content">
      <div class="content">
        <span class="users">尊敬的用户：</span><br />
        <span class="text">
          感谢您选择明亚配置保险方案！关注“明亚保险经纪”微信服务号，您可免费使用电话医生、快速问诊、报告解读、在线购药、儿童生长发育咨询、各类健康测评等增值服务！期待您的持续关注哦！
        </span>
        <span class="text">
          如有疑问您可致电明亚保险经纪全国统一客服热线400-172-6888、400-612-8688，我们将竭诚为您服务！
        </span>
      </div>
      <div class="imgs">
        <div class="public_number">
          <img
            :src="wxQrCode"
            alt="QR code"
            class="QR_code"
          />
          <div class="scan_QRcode">微信扫描二维码可关注“明亚保险经纪"微信服务号</div>
        </div>
        <!-- <div class="mini">
          <img
            src="@/assets/img/customerService/miniProgram.png"
            alt="QR code"
            class="QR_code"
          />
          <div class="scan_QRcode">小程序</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getSelfMediaList } from '@/api/contactUs.js'
import ItemTitle from "@/components/common/itemTitle";
export default {
  components: {
    ItemTitle,
  },
  data() {
    return {
      wxQrCode: "",
    };
  },
  created() {
    this.getData()
    // this.$emit("loading", false);
  },
  methods: {
    // 获取页面数据
    async getData() {
      const res = await getSelfMediaList()
      const findObj = res.list.find(item => item.id === 1)
      this.wxQrCode = findObj.d2_code
      this.$emit('loading', false)
    },
  },
};
</script>

<style lang="scss" scoped>
.policy-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 15px;
  .content {
    width: 100%;
    color: #212529;
    span {
      display: inline-block;
    }
    .users {
      margin-bottom: 5px;
    }
    .text {
      text-indent: 2em;
    }
  }
  .imgs {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .scan_QRcode {
      text-align: center;
      color: #666;
      font-size: 0.13rem;
    }
    .QR_code {
      width: 2.4rem;
      height: 2.4rem;
      margin: 0.3rem 0 0.1rem;
    }
    .public_number{
      text-align: center;
    }
  }
}

@media only screen and (max-width: $moble_width) {
  .mini {
    margin-bottom: 2.2rem;
  }
  img {
    margin: 0.5rem 0.5rem 0 !important;
  }
}
</style>
